import { render, staticRenderFns } from "./StaticPrivacyPolicy.vue?vue&type=template&id=00610e96&scoped=true&"
import script from "./StaticPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./StaticPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./StaticPrivacyPolicy.vue?vue&type=style&index=0&id=00610e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00610e96",
  null
  
)

export default component.exports